/*
  custom-atc.js
  Handles buttons in Rich Text Custom / Image With Text Custom sections.

  data-custom-atc="cart"    -> adds to cart via AJAX, then opens cart drawer or notification
  data-custom-atc="scroll"  -> smooth-scrolls to the product form

  Uses event delegation on document, so it works for sections added or
  reloaded in the theme editor without any re-initialisation.
*/
(function () {
  'use strict';

  if (window.__customAtcInit) return;
  window.__customAtcInit = true;

  var FORM_SELECTORS = [
    '#MainContent nido-bundle-builder',
    'nido-bundle-builder',
    '[id^="ProductInfo-"] variant-selects',
    '[id^="ProductInfo-"] product-form',
    'product-form',
    'form[data-type="add-to-cart-form"]'
  ];

  function visibleMatch(selector) {
    try {
      return Array.from(document.querySelectorAll(selector)).find(function (el) {
        return el.getClientRects().length && !el.closest('[hidden]');
      });
    } catch (error) { return null; }
  }

  function findProductForm() {
    for (var selector of FORM_SELECTORS) {
      var el = visibleMatch(selector);
      if (el) return el;
    }
    return null;
  }

  function resolveScrollTarget(btn) {
    var target = (btn.getAttribute('data-scroll-target') || '').trim();
    if (!target || ['product-form', '#product-form', '.product-form'].includes(target)) {
      return findProductForm();
    }
    return visibleMatch(target) || findProductForm();
  }

  function scrollToForm(btn) {
    var el = resolveScrollTarget(btn);
    if (!el) return;
    var header = document.querySelector('.section-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = Math.max(0, window.scrollY + el.getBoundingClientRect().top - offset - 20);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    var focusTarget = el.querySelector('[data-size-slot="1"] button:not(:disabled), input:not([type="hidden"]):not(:disabled), select:not(:disabled), button:not(:disabled)');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function getVariantId(btn) {
    // Prefer the live value from the real product form so the button always
    // respects whatever variant the customer currently has selected.
    var input =
      document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') ||
      document.querySelector('.product-variant-id') ||
      document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');

    if (input && !input.disabled && input.value) return input.value;

    // Fallback to the variant rendered into the button by Liquid.
    return btn.getAttribute('data-variant-id') || null;
  }

  function getQuantity() {
    var qty = document.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]');
    var value = qty ? parseInt(qty.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function setLoading(btn, isLoading) {
    if (isLoading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('data-atc-loading', 'true');
      btn.style.opacity = '0.65';
      btn.style.pointerEvents = 'none';
    } else {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('data-atc-loading');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }
  }

  function addToCart(btn) {
    var variantId = getVariantId(btn);

    // No variant available (sold out, or not a product page) -> send them to
    // the real form so they see the proper state instead of nothing happening.
    if (!variantId) {
      scrollToForm(btn);
      return;
    }

    var cart = getCartElement();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', getQuantity());

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }

    setLoading(btn, true);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        setLoading(btn, false);

        // Shopify returns a `status` field only on errors.
        if (response.status) {
          scrollToForm(btn);
          return;
        }

        if (cart && cart.renderContents) {
          cart.renderContents(response);
        } else {
          // cart_type is "page" or the cart element is missing.
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        setLoading(btn, false);
        scrollToForm(btn);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-custom-atc]') : null;
    if (!btn) return;
    if (btn.getAttribute('data-atc-loading') === 'true') return;

    event.preventDefault();

    if (btn.getAttribute('data-custom-atc') === 'cart' && !visibleMatch('nido-bundle-builder')) {
      addToCart(btn);
    } else {
      scrollToForm(btn);
    }
  });
})();